import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./component/home.component";
import { RegisterComponent } from "./component/register.component";
import { ActivationComponent } from "./component/activation.component";
import { LoginComponent } from "./component/login.component";
import { AboutComponent } from "./component/about.component";
import { TOUComponent } from "./component/tou.component";
import { KilowantUComponent } from "./component/kilowant-u.component"
import { PrivacyPolicyComponent } from "./component/privacy-policy.component";
import { UserHomeComponent } from "./component/user-home.component";
import { FAQComponent } from "./component/faq.component";
import { OurStoryComponent } from "./component/our-story.component";
import { ForgotPasswordComponent } from "./component/forgot-password.component";
import { LoginSetupComponent } from "./component/login-setup.component";
import { UserDetailsComponent } from "./component/user-details.component";
import { ClientListComponent } from "./component/advisor/client-list.component";
import { ClientDetailsComponent } from "./component/advisor/client-details.component";
import { AccountListComponent } from "./component/account-list.component";
import { AccountDetailsComponent } from "./component/account-details.component";
import { BuyOfferListComponent } from "./component/buy-order-list.component";
import { BuyOfferAddComponent } from "./component/buy-order-add.component";
import { ContractListComponent } from "./component/contract-list.component";
import { ExistingContractDetailsComponent } from "./component/existing-contract-details.componet";

import { AITaskListComponent } from "./component/ai-task-list.component";

import { SellerHomeComponent } from "./component/seller/seller-home.component";
import { SellerHomeSellOfferComponent } from "./component/seller/seller-sell-offers.component";
import { SellerHomeBuyOfferComponent } from "./component/seller/seller-buy-offers.component";
import { SellerHomeAcceptedOfferComponent } from "./component/seller/seller-accepted-offers.component";
import { SellerFeesComponent } from "./component/seller/seller-fees.component";

import { SellerAccountComponent } from "./component/seller/seller-account.component";
import { SellerUtilitiesComponent } from "./component/seller/seller-utilities.component";
import { SellerTermsListComponent } from "./component/seller/seller-terms-list.component";
import { SellerVerifyContractComponent } from "./component/seller/seller-verify-contract.component";
import { SellerViewContractComponent } from "./component/seller/seller-view-contract.component";
import { SellerBulkImportComponent } from "./component/seller/seller-bulk-import.component";
import { BuyOfferDetailsComponent } from "./component/buy-offer-details.component";
import { SellOfferDetailsComponent } from "./component/selloffer-details.component";
import { SellerBatchExportListComponent } from "./component/seller/seller-batch-export.component";

import { ViewContractComponent } from "./component/view-contract.component";

export const routes: Routes = [
    {
        path: "user/registration",
        component: RegisterComponent
    },
    {
        path: "user/activation",
        component: ActivationComponent
    },
    {
        path: "about",
        component: AboutComponent
    },
    {
        path: "user/login",
        component: LoginComponent
    },
    {
        path: "user/logout",
        component: LoginComponent
    },
    {
        path: "tou",
        component: TOUComponent
    },
    {
        path: "user/kilowant-u",
        component: KilowantUComponent
    },
    {
        path: "user/faq",
        component: FAQComponent
    },
    {
        path: "faq",
        component: FAQComponent
    },
    {
        path: "our-story",
        component: OurStoryComponent
    },    
    {
        path: "privacy-policy",
        component: PrivacyPolicyComponent
    },
    {
        path: "user/forgot-password",
        component: ForgotPasswordComponent
    },
    {
        path: "user/login-setup",
        component: LoginSetupComponent
    },
    {
        path: "user/home",
        component: UserHomeComponent
    },
    {
        path: "user/details",
        component: UserDetailsComponent
    },

    {
        path: "client/list",
        component: ClientListComponent
    },
    {
        path: "client/details/:id",
        component: ClientDetailsComponent
    },
    {
        path: "client/add",
        component: ClientDetailsComponent
    },

    {
        path: "account/list",
        component: AccountListComponent
    },
    {
        path: "account/details/:id",
        component: AccountDetailsComponent
    },
    {
        path: "account/add",
        component: AccountDetailsComponent
    },
    {
        path: "account/init",
        component: AccountDetailsComponent
    },
    {
        path: "account/onboarding",
        component: AccountDetailsComponent
    },
    {
        path: "account/onboarding/:id",
        component: AccountDetailsComponent
    },
    {
      path: "priceplans/list",
        component: ContractListComponent
    },
    {
      path: "priceplans/details/:id",
        component: ExistingContractDetailsComponent
    },
    {
      path: "priceplans/details",
        component: ExistingContractDetailsComponent
    },

    {
        path: "ai-task/list",
        component: AITaskListComponent
    },
    {
        path: "seller/home",
        component: SellerHomeComponent,
        children: [
            {
                path: "sell-offers",
                component: SellerHomeSellOfferComponent
            },
            {
                path: "buy-offers",
                component: SellerHomeBuyOfferComponent
            },
            {
                path: "accepted-offers",
                component: SellerHomeAcceptedOfferComponent
            }
        ]
    },
    {
        path: "seller/my-account",
        component: SellerAccountComponent
    },
    {
        path: "seller/my-account/onboarding",
        component: SellerAccountComponent
    },
    {
        path: "seller/company/utilities",
        component: SellerUtilitiesComponent
    },
    {
        path: "seller/company/utilities/:action",
        component: SellerUtilitiesComponent
    },
    {
        path: "seller/terms",
        component: SellerTermsListComponent
    },
    {
        path: "seller/terms/:action",
        component: SellerTermsListComponent
    },
    {
        path: "seller/sell-offer/bulk-import",
        component: SellerBulkImportComponent
    },
    {
      path: "seller/priceplans/verify/:id",
        component: SellerVerifyContractComponent
    },
    {
      path: "seller/priceplans/view/:id",
        component: SellerViewContractComponent
    },
    {
        path: "seller/fees",
        component: SellerFeesComponent
    },
    {
        path: "seller/batch-export",
        component: SellerBatchExportListComponent
    },
    {
        path: "buy-offer/list",
        component: BuyOfferListComponent
    },
    {
        path: "buy-offer/edit/:id",
        component: BuyOfferListComponent
    },
    {
        path: "buy-offer/details/:id",
        component: BuyOfferDetailsComponent
    },
    {
        path: "buy-offer/add",
        component: BuyOfferAddComponent
    },
    {
        path: "sell-offer/details/:id/:accountId",
        component: SellOfferDetailsComponent
    },
    {
      path: "view-priceplan/:id",
        component: ViewContractComponent
    },
    {
      path: "view-existing-priceplan/:id",
        component: ViewContractComponent
    },
    {
        path: "admin-kilowant-area",
        loadChildren: () => import("./admin/admin.module").then(m => m.AdminModule)
    },
    //AFFILIATES SECTION START
    {
        path: "msashin",
        component: HomeComponent
    },
    {
        path: "arandall",
        component: HomeComponent
    },
    {
        path: "pfenton",
        component: HomeComponent
    },
    {
        path: "tommyd",
        component: HomeComponent
    },
    {
        path: "ctk",
        component: HomeComponent
    },
    {
        path: "bfain",
        component: HomeComponent
    },
    {
        path: "hungryhaven",
        component: HomeComponent
    },
    {
        path: "easyclean",
        component: HomeComponent
    },
    {
        path: "myoung",
        component: HomeComponent
    },
    {
        path: "SRICC",
        component: HomeComponent
    },
    {
        path: "GNCC",
        component: HomeComponent
    },
    {
        path: "CRICC",
        component: HomeComponent
    },
    {
        path: "RIFDA",
        component: HomeComponent
    },
    {
        path: "zachbanas",
        component: HomeComponent
    },
    //AFFILIATES SECTION END
    {
        path: "",
        component: HomeComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: "enabledBlocking"
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
